const selectors = {
  dancersList: (state) => state.dashboard.dancersList,
  loading: (state) => state.dashboard.loadingListStatus,
};

export { selectors };
